// i18n namespace "services" (spec c.7 §4, COO decisions 1 and 4). Three SAP-first rows;
// e-invoicing folds into SAP finance; Haptik appears once, as "built on". No counters.

export const en = {
  label: "Services",
  title: "What we do in SAP",
  lead: "Finance and logistics on SAP S/4HANA, and AI assistants connected to your SAP.",
  codesLabel: "SAP modules and interfaces",
  discuss: "Discuss",
  items: {
    finance: {
      title: "SAP finance & e-invoicing",
      text: "Finance and controlling on S/4HANA, the month-end close, and CFDI e-invoicing compliance for Mexico.",
    },
    logistics: {
      title: "SAP logistics & warehouse",
      text: "Purchasing, sales, transportation and extended warehouse management (EWM), from design through multi-site rollouts.",
    },
    ai: {
      title: "AI assistants connected to SAP",
      text: "Assistants that answer questions and handle routine tasks with your SAP data, through standard SAP interfaces. Built on Haptik.",
    },
  },
};

export const es = {
  label: "Servicios",
  title: "Qué hacemos en SAP",
  lead: "Finanzas y logística en SAP S/4HANA, y asistentes de IA conectados a tu SAP.",
  codesLabel: "Módulos e interfaces SAP",
  discuss: "Hablemos",
  items: {
    finance: {
      title: "Finanzas SAP y facturación electrónica",
      text: "Finanzas y controlling en S/4HANA, el cierre contable y el cumplimiento de facturación electrónica CFDI en México.",
    },
    logistics: {
      title: "Logística y almacén en SAP",
      text: "Compras, ventas, transporte y gestión avanzada de almacenes (EWM), del diseño a la implementación en varias plantas.",
    },
    ai: {
      title: "Asistentes de IA conectados a SAP",
      text: "Asistentes que responden preguntas y resuelven tareas rutinarias con tus datos de SAP, mediante interfaces estándar de SAP. Construidos sobre Haptik.",
    },
  },
};

export const fr = {
  label: "Services",
  title: "Ce que nous faisons dans SAP",
  lead: "Finance et logistique sur SAP S/4HANA, et des assistants IA connectés à votre SAP.",
  codesLabel: "Modules et interfaces SAP",
  discuss: "En parler",
  items: {
    finance: {
      title: "Finance SAP et facturation électronique",
      text: "Finance et contrôle de gestion sur S/4HANA, la clôture mensuelle et la conformité de la facturation électronique CFDI au Mexique.",
    },
    logistics: {
      title: "Logistique et entrepôt SAP",
      text: "Achats, ventes, transport et gestion avancée des entrepôts (EWM), de la conception aux déploiements multisites.",
    },
    ai: {
      title: "Assistants IA connectés à SAP",
      text: "Des assistants qui répondent aux questions et traitent les tâches courantes avec vos données SAP, via les interfaces SAP standard. Construits sur Haptik.",
    },
  },
};

export const pt = {
  label: "Serviços",
  title: "O que fazemos em SAP",
  lead: "Finanças e logística no SAP S/4HANA, e assistentes de IA conectados ao seu SAP.",
  codesLabel: "Módulos e interfaces SAP",
  discuss: "Conversar",
  items: {
    finance: {
      title: "Finanças SAP e faturamento eletrônico",
      text: "Finanças e controladoria no S/4HANA, o fechamento mensal e a conformidade do faturamento eletrônico CFDI no México.",
    },
    logistics: {
      title: "Logística e armazém no SAP",
      text: "Compras, vendas, transporte e gestão avançada de armazéns (EWM), do desenho às implantações em várias unidades.",
    },
    ai: {
      title: "Assistentes de IA conectados ao SAP",
      text: "Assistentes que respondem perguntas e resolvem tarefas rotineiras com os seus dados do SAP, por meio de interfaces padrão do SAP. Construídos sobre o Haptik.",
    },
  },
};
